var _defs, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgHealthFeed = function SvgHealthFeed(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "1031 60 17.82 17.82",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "MHF_icon",
    "data-name": "MHF icon",
    transform: "translate(1031 60)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path_1361",
    "data-name": "Path 1361"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7832",
    "data-name": "Rectangle 7832",
    className: "health-feed-1",
    width: 7.91,
    height: 1,
    transform: "translate(4.93 8.31)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_1362",
    "data-name": "Path 1362"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7833",
    "data-name": "Rectangle 7833",
    className: "health-feed-1",
    width: 1,
    height: 7.75,
    transform: "translate(8.41 4.93)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_1363",
    "data-name": "Path 1363"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8423",
    "data-name": "Path 8423",
    className: "health-feed-1",
    d: "M8.91,17.82a8.91,8.91,0,1,1,8.91-8.91,8.91,8.91,0,0,1-8.91,8.91ZM8.91,1a7.91,7.91,0,1,0,7.91,7.91A7.91,7.91,0,0,0,8.91,1Z"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHealthFeed, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/healthFeed.ea07c76d.svg";
export { ForwardRef as ReactComponent };